// extracted by mini-css-extract-plugin
export var uploadFileBlockContent = "upload-file-block__content_nQEbbPSYZ9t7dh8CE5fP";
export var uploadFileBlockDropzone = "upload-file-block__dropzone_MT9J4_mrAN9ZPjpzoKiv";
export var uploadFileBlockDropzoneNonActive = "upload-file-block__dropzone_non-active_PQC_hLQFaVL9VvfSBx2u";
export var uploadFileBlockEmailCell = "upload-file-block__email-cell_DWXqV2SaEE3v9HBQ3Qj8";
export var uploadFileBlockHeader = "upload-file-block__header_VbhyjrFrH1mbmGCynryB";
export var uploadFileBlockIdCell = "upload-file-block__id-cell_a27y51ksIouXru2T2qRe";
export var uploadFileBlockList = "upload-file-block__list_baF3cu72sLJsNprKAiAY";
export var uploadFileBlockReviewPartition = "upload-file-block__review-partition_A5c4rFNlz1LPYswdDTbJ";
export var uploadFileBlockUploadPartition = "upload-file-block__upload-partition_qot1tk6clFfPOEcluojS";